export default {
    noResultsText: 'No results found',
    noChoicesText: 'No choices to choose from',
    itemSelectText: 'Press to select',
    uniqueItemText: 'Only unique values can be added',
    customAddItemText: 'Only values matching specific conditions can be added',
    apiSearching: 'Searching...',
    // addItemText: value => `Press Enter to add <b>"${sanitise(value)}"</b>`,
    // maxItemText: maxItemCount => `Only ${maxItemCount} values can be added`,
    customChoiceValue: 'Other',
}
